import {atom, useRecoilState, useRecoilValue} from 'recoil';
import {Company} from '../../interfaces/company';

const currentCompanyState = atom<Company | null>({
  key: 'currentCompany',
  default: null,
});

/**
 * @deprecated Use useSafeCurrentCompanyUuid along with useCompany.
 */
export function useCurrentCompanyState() {
  return useRecoilState(currentCompanyState);
}

/**
 * @deprecated Use useSafeCurrentCompanyUuid along with useCompany.
 */
export function useCurrentCompany() {
  return useRecoilValue(currentCompanyState);
}

/**
 * @deprecated Use useSafeCurrentCompanyUuid along with useCompany.
 */
export function useSafeCurrentCompany() {
  const company = useRecoilValue(currentCompanyState);

  if (!company) {
    throw Error('Current company is null');
  }

  return company;
}

export const useSafeCurrentCompanyUuid = () => {
  const company = useRecoilValue(currentCompanyState);

  if (!company) {
    throw Error('Current company is null');
  }

  return company.uuid;
};

export const useCurrentCompanyUuid = () => {
  const company = useRecoilValue(currentCompanyState);

  return company?.uuid || '';
};
